/** The third of the alignment icons (left and center come from the Highlights section). */
const AlignRight = () => (
  <svg width="20" height="16" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
    <path
      fill="currentColor"
      d="M1.111 2.667H18.89C19.503 2.667 20 2.07 20 1.333 20 .597 19.503 0 18.889 0H1.11C.497 0 0 .597 0 1.333c0 .737.497 1.334 1.111 1.334M18.889 9.333H1.11C.497 9.333 0 8.736 0 8s.497-1.333 1.111-1.333H18.89C19.503 6.667 20 7.264 20 8s-.497 1.333-1.111 1.333M10 16h8.889C19.503 16 20 15.403 20 14.667c0-.737-.497-1.334-1.111-1.334H10c-.614 0-1.111.597-1.111 1.334C8.889 15.403 9.386 16 10 16"
    />
  </svg>
);

export default AlignRight;
